<template>
    <!-- Objects types -->
    <el-form-item no-help :label="$t(label) + ' *'" prop="typeObjet" data-test="post-form-object-type">
        <el-cascader
                id="cascaderBien"
                data-test="post-form-cascader-bien"
                v-model="typeObjet"
                :show-all-levels="false"
                :options="optionsObjectTypes"
                :props="{ expandTrigger: 'click', checkStrictly: true, emitPath: false }"
                :collapse-tags="true"
                filterable
                clearable
                :disabled="desactiverChamp"
                @change="$emit('typeChange')"
        ></el-cascader>
    </el-form-item>
</template>

<script>
import { mapState } from 'vuex'
import { getObjectTypes } from '@/services/postsData'
import _groupBy from 'lodash/groupBy'
import _keyBy from 'lodash/keyBy'
import _omit from 'lodash/omit'
import _remove from 'lodash/remove'
import _each from 'lodash/each'
import _filter from 'lodash/filter'
import { getFromSnake } from '@/helpers/functions/getFromSnake'

export default {
  name: 'PostFormObjectType',
  props: {
    post: Object,
    desactiverChamp: Boolean,
    typeSaisie: String,
    label: { type: String, default: 'posts.edit.propertyType' },
    minLevel: { type: Number, default: 2 },
    maxLevel: { type: Number, default: 99 },
    isProgramBailleur: { type: Boolean, default: false }
  },
  data: function () {
    return {
      type_objet: [],
      optionsObjectTypes: [],
      programBailleur: false
    }
  },
  beforeMount () {
    this.checkTypeObjet()
  },
  computed: {
    ...mapState('posts', ['filter']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    // Contexte navigation (liste / URL) — distinct de post.annonceParente (relation persistée)
    filterAnnonceParente () {
      return getFromSnake(this.filter, 'annonce_parente')
    },
    typeObjet: {
      get () {
        return getFromSnake(this.post, 'type_objet')
      },
      set (val) {
        this.$set(this.post, 'type_objet', val)
        this.$set(this.post, 'typeObjet', val)
      }
    }
  },
  watch: {
    post: {
      handler: function () {
        this.checkTypeObjet()
      }
    },
    filterAnnonceParente (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkTypeObjet()
      }
    }
  },
  methods: {
    async checkTypeObjet () {
      const typeObjet = parseInt(this.typeObjet, 10)
      const filterAnnonceParente = this.filterAnnonceParente

      if (typeObjet >= 3000 && typeObjet < 4000 && this.isBailleurSocial && !filterAnnonceParente) {
        this.type_objet = await getObjectTypes(null, null, 'PROMOTEUR')
      } else if (this.isBailleurSocial && !this.isProgramBailleur && !filterAnnonceParente) {
        this.type_objet = await getObjectTypes(null, null, 'BAILLEUR_SOCIAL')
      } else if (this.isBailleurSocial && this.isProgramBailleur && !filterAnnonceParente) {
        this.type_objet = await getObjectTypes(null, null, 'PROMOTEUR')
      } else if (this.isBailleurSocial && filterAnnonceParente) {
        this.type_objet = await getObjectTypes(filterAnnonceParente, null, 'PROMOTEUR')
      } else if (this.isPromoteur && filterAnnonceParente) {
        this.type_objet = await getObjectTypes(filterAnnonceParente, null, 'PROMOTEUR')
      } else {
        this.type_objet = await getObjectTypes(filterAnnonceParente)
      }
      this.optionsObjectTypes = this.objectTypesTree(this.type_objet)
    },
    objectTypesTree (data) {
      _remove(data, function (currentObject) {
        return currentObject.niveau < this.minLevel || currentObject.niveau > this.maxLevel
      }.bind(this))

      _each(data, function (object) {
        object.value = object.code
        object.label = object.libelle
        object.parentCode = getFromSnake(object, 'parent_code')
      })

      const groupedByParents = _groupBy(data, 'parentCode')
      const objectsByCode = _keyBy(data, 'code')

      _each(_omit(groupedByParents, undefined), function (children, parentCode) {
        if (objectsByCode[parentCode]) {
          objectsByCode[parentCode].children = children
        }
      })

      const results = _filter(objectsByCode, function (object) {
        // Afficher à la racine : soit les items au niveau minLevel,
        // soit les items orphelins (parent absent de la liste, ex. lots promoteur
        // où l'API ne retourne que les feuilles sans leur hiérarchie complète)
        const parentCode = getFromSnake(object, 'parent_code')
        return object.niveau === this.minLevel || !objectsByCode[parentCode]
      }.bind(this))
      return results
    }
  }
}
</script>
